module.exports = __webpack_public_path__ + "img/Progress-Report-Process-4.34fac7f9.png";